export const buildClassString = (classObject: { [className: string]: boolean | undefined | null }, baseClass?: string) => {
  let classesResult = baseClass ? baseClass.trim() + " " : "";
  Object.keys(classObject).forEach((className) => {
    if (classObject[className]) {
      classesResult += className.trim() + " ";
    }
  });
  return classesResult.replace(/[\s]+$/, "");
};
